import React from "react";
import { Controller } from "react-hook-form";

export function MeasurementSelect({
  control,
  name,
  label = "Units",
  className = "",
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => {
        const isImperial = value === true;

        return (
          <div className={`flex flex-col ${className}`}>
            {label && (
              <label className="text-xs font-medium mb-1 text-gray-600">
                {label}
              </label>
            )}

            <div className="relative flex w-44 h-8 rounded-lg border border-gray-300 bg-gray-100 overflow-hidden">
              {/* Sliding background */}
              <div
                className={`absolute top-0 left-0 h-full w-1/2 bg-white rounded-lg transition-transform duration-200 ${
                  isImperial ? "translate-x-0" : "translate-x-full"
                }`}
              />

              {/* IN / LBS */}
              <button
                type="button"
                onClick={() => onChange(true)}
                className={`flex-1 relative z-10 text-xs font-medium transition-colors ${
                  isImperial
                    ? "text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                IN / LBS
              </button>

              {/* CM / KG */}
              <button
                type="button"
                onClick={() => onChange(false)}
                className={`flex-1 relative z-10 text-xs font-medium transition-colors ${
                  !isImperial
                    ? "text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                CM / KG
              </button>
            </div>
          </div>
        );
      }}
    />
  );
}